import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(function (module) {
    "use strict";

    module.component("fileValidationErrors", {
        template: require('./fileValidationErrorsComponent.html'),
        bindings: {
            resolve: "<",
            dismiss: "&",
            close: "&"
        },
        controller: [
            "$scope",
            AgGridService.componentName,
            angularServicesNames.$translate,
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                agGridService: AgGridService,
                $translate: ng.translate.ITranslateService
            ) {
                var $ctrl = this;

                $scope.$on("LanguageChanged", () => agGridService.refreshGridLanguage($ctrl.gridApi));

                const marketColumn = {
                    field: "market",
                    headerValueGetter: () => $translate.instant("MARKET.FILE_ERRORS.MARKET")
                };

                const productCodeColumn = {
                    field: "productCode",
                    headerValueGetter: () => $translate.instant("MARKET.FILE_ERRORS.CODE")
                };

                const fieldColumn = {
                    field: "field",
                    headerValueGetter: () => $translate.instant("MARKET.FILE_ERRORS.FILED"),
                    template: "{{data.field ? ('MARKET.FILE_ERRORS.FIELDS.' + data.field | translate) : '' }}"
                };

                const errorColumn = {
                    field: "error",
                    headerValueGetter: () => $translate.instant("MARKET.FILE_ERRORS.ERROR"),
                    template: "{{ 'MARKET.FILE_ERRORS.TYPES.' + data.error | translate }}"
                };

                $ctrl.$onInit = function () {
                    const includeProductCodeColumn = $ctrl.resolve.items.filter(
                        ({
                            productCode
                        }: $TSFixMe) => !!productCode
                    ).length > 0;

                    const columnDefs = includeProductCodeColumn
                        ? [marketColumn, productCodeColumn, fieldColumn, errorColumn]
                        : [marketColumn, fieldColumn, errorColumn];

                    $ctrl.gridOptions = {
                        columnDefs,
                        angularCompileRows: true,
                        defaultColDef: {
                            sortable: true,
                            resizable: true
                        },
                        floatingFilter: true,
                        animateRows: true,
                        pagination: true,
                        paginationPageSize: 10,
                        rowGroupPanelShow: "never",
                        domLayout: "autoHeight",
                        suppressMultiSort: true,
                        localeTextFunc: agGridService.transalteFunc,
                        suppressHorizontalScroll: true,
                        suppressDragLeaveHidesColumns: true,
                        onGridReady: (config: $TSFixMe) => {
                            $ctrl.gridApi = config.api;
                            $ctrl.gridApi.setRowData($ctrl.resolve.items);
                            config.api.sizeColumnsToFit();
                        },
                        onGridSizeChanged: (config: $TSFixMe) => config.api.sizeColumnsToFit()
                    };
                };
                $ctrl.close = function () {
                    $ctrl.close({});
                };
            }
        ]
    });

})(angular.module("topline.modules"));
